import axios from "axios";

export const HTTP_VERBS = {
  POST: "post",
  GET: "get",
  DELETE: "delete",
  PUT: "put",
};

const headersConfig = (token) => {
  return {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };
};

const getParamsWithToken = (params) => {
  return {
    ...params,
    token: localStorage.getItem('_SESSION_REPORT_')
  }
}

export const requestHttp = async ({
  method = HTTP_VERBS.POST,
  endpoint,
  data = {}, // body
  params = {},
  token = "",
  isAuth = false
}) => {
  try {
    const baseUrl = isAuth ? process.env.REACT_APP_API_AUTH_URL : process.env.REACT_APP_API_HISTORICAL_REPORT_URL;
    const url = baseUrl + endpoint;
    const options = {
      method,
      url,
      data,
      params: getParamsWithToken(params),
      headers: headersConfig(token),
    };
    return await axios(options);
  } catch (error) {
    throw error;
  }
};
